import {JackpotWidgetCollectingLabelMrGreenBox} from "./jackpot-widget-collecting-label.mrgreen.box";

export const JackpotWidgetCollectingLabelMrGreenCisBox = JackpotWidgetCollectingLabelMrGreenBox;
